import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title, Text } from '../../../components/presentation/Text'
import { getPublicUrl } from '../../../utils/env/env'
import { useColors } from '../../../packages/kiti/components/theme/_hooks/colors'
import { useEnv } from '../../../utils/contexts/EnvContext'
import Center from '../../../components/helpers/Center'
import Container from '../../../components/structure/Container'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import HelpTextLauncher from '../../../containers/help/HelpTextLauncher'
import Image from '../../../components/presentation/Image'
import ListNotifications from '../../../components/messenger/ListNotifications'
import Logo from '../../../components/shapes/Logo'
import PublicTemplate from '../../../components/templates/PublicTemplate'
import Separator from '../../../components/helpers/Separator'
import SeparatorWrapper from '../../../components/helpers/SeparatorWrapper'

const Template = ({ children, footer }) => {
  const { t } = useTranslation('session')
  const env = useEnv()
  const colors = useColors()

  return (
    <PublicTemplate>
      <FlexGrid align="stretch" justify="stretch" minHeight="100vh">
        <FlexCol flex={1}>
          <SeparatorWrapper weight={12} height="100%" usePadding>
            <Container maxWidth="22rem">
              <FlexGrid align="stretch" justify="space-between" direction="column">
                <Logo />
                <Separator weight={4} />

                {children}

                <Separator weight={8} />

                <div>
                  {footer}
                  <HelpTextLauncher />
                </div>
              </FlexGrid>
            </Container>
          </SeparatorWrapper>
        </FlexCol>

        <FlexCol flex={2} bgColor={colors.dark1} hideOn="mdd">
          <Center>
            <Image src={getPublicUrl(env, 'illustration.png')} width="28rem" />
            <Separator weight={6} />
            <Title color={colors.white} size="h3">
              {t('loginTemplate.platformTitle')}
            </Title>
            <Text color={colors.white} align="center" maxWidth="32">
              {t('loginTemplate.platformDescription')}
            </Text>
          </Center>
        </FlexCol>
      </FlexGrid>
      <ListNotifications />
    </PublicTemplate>
  )
}

export default Template
